<template>
    <div>
        <div class="m-portlet">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <el-button @click="handleAddLimit()">添加新额度</el-button>
                    </div>
                </div>
            </div>
            <vue-scroll :ops="$ops">
            <div class="card-body" :style="{'max-height':clientHeight-96-61.59+'px'}">
                <table class="table " v-loading="loading">
                    <thead>
                    <tr>
                        <th>班主任</th>
                        <th>开始时间</th>
                        <th>结束时间</th>
                        <th>总额度</th>
                        <th>剩余额度</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in headTeacherLimits">
                        <td>{{item.name}}</td>
                        <td>
                            <el-date-picker
                                    v-model="item.start_date"
                                    size="small"
                                    type="date"
                                    :clearable="false"
                                    value-format="yyyy-MM-dd"
                                    placeholder="日期"
                                    style="width: 150px">
                            </el-date-picker>
                        </td>
                        <td>
                            <el-date-picker
                                    v-model="item.end_date"
                                    size="small"
                                    type="date"
                                    :clearable="false"
                                    value-format="yyyy-MM-dd"
                                    placeholder="日期" style="width: 150px">
                            </el-date-picker>
                        </td>
                        <td>
                            <el-input v-model="item.money" placeholder="请输入金额" size="small" style="width: 100px"></el-input>
                        </td>
                        <td>
                            {{item.amount}}
                        </td>
                        <td>
                            <el-button size="mini" @click="handleChangeHeadTeacherLimit(item.id,item)">修改</el-button>
                            <el-button size="mini" @click="handleLimitDetail(item.id)">使用详情</el-button>
                            <el-button size="mini" @click="handleHistoryLimit(item.id,item.headTeacher_id)">历史信息</el-button>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <!--<div class="text-center m-t-10">-->
                <!--<el-pagination-->
                <!--@size-change="handleSizeChange"-->
                <!--@current-change="handleCurrentChange"-->
                <!--:current-page="currentPage"-->
                <!--:page-sizes="[10, 20, 50, 100]"-->
                <!--:page-size="10"-->
                <!--layout="total, sizes, prev, pager, next, jumper"-->
                <!--:total="total">-->
                <!--</el-pagination>-->
                <!--</div>-->
            </div>
            </vue-scroll>
        </div>
    </div>
</template>

<script>
    export default {
        name: "headTeacher-limit",
        data() {
            return {
                path: '/headTeacher/limit',
                loading: true,
                semesters: [],
                headTeacherLimits: {},
                currentPage: 1,
                currentPageSize: 10,
                total: 1,

                limitDetail:{
                    loading: true,
                    headTeacherLimits_bills: {},
                },
                historyLimit:{
                    loading: true,
                    headTeacherHistoryLimits: {},
                },
                createLimit:{
                    loading: true,
                    button_loading: false,
                    headTeacherLimits: [],
                }
            }
        },
        created() {
            this.handleList();
            this.handleCreate();
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleList() {
                this.$wApi.send(this.path, 'list',{})
            },
            handleData(event, data,status) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'list':
                        if (Object.keys(data.headTeacherLimits).length > 0) {
                            this.headTeacherLimits=data.headTeacherLimits;
                        }else{
                            this.headTeacherLimits = new Object();
                        }
                        this.loading=false;
                        break;
                    case 'update_headTeacherLimit':
                        if(status=='success') {
                            this.$set(this.headTeacherLimits, data.headTeacherLimit.id, data.headTeacherLimit);
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                        }
                        break;
                    case 'get_detail':
                        if (Object.keys(data.headTeacherLimits_bills).length > 0) {
                            this.limitDetail.headTeacherLimits_bills=data.headTeacherLimits_bills;
                        } else {
                            this.limitDetail.headTeacherLimits_bills = new Object();
                        }
                        this.limitDetail.loading=false;
                        break;
                    case 'get_history':
                        if (Object.keys(data.headTeacherHistoryLimits).length > 0) {
                            this.historyLimit.headTeacherHistoryLimits=data.headTeacherHistoryLimits;
                        } else {
                            this.historyLimit.headTeacherHistoryLimits = new Object();
                        }
                        this.historyLimit.loading=false;
                        break;
                    case 'get_headTeachers':
                        this.createLimit.headTeacherLimits = data.headTeacherLimits;
                        this.createLimit.loading=false;
                        break;
                    case 'store_headTeacherLimits':
                        if (Object.keys(data.headTeacherLimits).length > 0) {
                            this.headTeacherLimits=data.headTeacherLimits;
                        }else{
                            this.headTeacherLimits = new Object();
                        }
                        this.createLimit.button_loading = false;
                        this.loading=false;
                        this.$Win.closeModal();
                        if(status=='success'){
                            this.$message({
                                message: '信息添加成功',
                                type: 'success'
                            });
                        }
                        break;
                    case 'store_headTeacherLimits_error':
                        this.createLimit.button_loading = false;
                        this.loading=false;
                        break;
                }
            },
            handleChangeHeadTeacherLimit(id, item) {
                this.$wApi.send(this.path, 'update_headTeacherLimit',{'id':id,'headTeacherLimit':item})
            },
            handleLimitDetail(id){
                this.$Win.openModal('LimitDetail', 600, 500, '使用详情',{'headTeacherLimit_id':id});
            },
            handleAddLimit() {
                this.$Win.openModal('CreateLimit', 900, 600, '创建班主任额度');
            },
            handleHistoryLimit(id,headTeacher_id) {
                this.$Win.openModal('HistoryLimit', 700, 500, '历史信息',{'headTeacherLimit_id':id,'headTeacher_id':headTeacher_id});
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleList(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleList(this.currentPage, this.currentPageSize)
            }
        }
    }
</script>

<style scoped>

</style>
